import React from 'react';
import AccountsManagementPage from '../components/accounts/AccountsManagementPage';

const SavingsAccountsPage: React.FC = () => (
  <AccountsManagementPage
    title="Savings Accounts"
    helperText="Manage your savings accounts, including editing and archiving old accounts."
    accountType="savings"
    accountCategory="asset"
  />
);

export default SavingsAccountsPage;
